import { getLanguage } from '@/lib/config';
import { breakpoints, h3, imageLoaderResponsive, mediaQueries, paragraph } from '@/theme/lib';
import Image from 'next/image';
import styled from 'styled-components';
import StyledButton from '../Button';

export interface EventCardProps {
  id: string;
  image?: {
    altText: string | null;
    url: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
  } | null;
  title: string;
  description: string;
  cta?: {
    title: string;
    url: string;
  } | null;
}

const StyledEventCard = styled.div`
  padding: 1.25rem 1rem;
  border-radius: ${(props) => props.theme.config.cards.event.containerBorderRadius.mobile};
  border: 1px solid ${(props) => props.theme.colors.cards.event.border};
  color: ${(props) => props.theme.colors.cards.event.text};
  background-color: ${(props) => props.theme.colors.cards.event.background};

  h4 {
    ${h3}
  }

  .event-card__description {
    ${paragraph}
    margin-top: 1rem;
  }

  a {
    margin-top: 1rem;
    color: ${(props) => props.theme.colors.cards.event.ctaText};
    background: ${(props) => props.theme.colors.cards.event.ctaBg};
  }

  ${mediaQueries.md} {
    padding: 2rem;
    border-radius: ${(props) => props.theme.config.cards.event.containerBorderRadius.desktop};

    .event-card__description {
      margin-top: 1.125rem;
    }

    a {
      margin-top: 2rem;
    }
  }
`;

const StyledImageWrapper = styled.div`
  margin-bottom: 1rem;

  ${mediaQueries.md} {
    margin-bottom: 2rem;
  }

  span {
    width: 100% !important;
    height: 100% !important;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: ${(props) => props.theme.config.cards.event.imageBorderRadius};
  }
`;

export default function EventCard(data: EventCardProps) {
  const language = getLanguage();

  return (
    <StyledEventCard>
      {data.image && (
        <StyledImageWrapper>
          <Image
            src={data.image.url}
            alt={data.image.altText || ''}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            width="686"
            height="360"
            loader={imageLoaderResponsive(686, 360)}
            sizes={`(min-width: ${breakpoints.md}px) 686px,
                  292px`}
          />
        </StyledImageWrapper>
      )}
      <h4 lang={language !== 'en' ? language : undefined}>{data.title}</h4>
      <p className="event-card__description" lang={language !== 'en' ? language : undefined}>{data.description}</p>
      {data.cta && (
        <StyledButton href={data.cta.url} primary lang={language !== 'en' ? language : undefined}>
          {data.cta.title}
        </StyledButton>
      )}
    </StyledEventCard>
  );
}
